<form [formGroup]="TieForm" (ngSubmit)="Submit(TieForm)" novalidate>
    <h1 mat-dialog-title>Start Tie-Breaker Round</h1>
    <div mat-dialog-content>
        <p>There are {{Nominees.length}} nominees tied for this judging round:</p>
        <ul>
            <li *ngFor="let n of Nominees">{{n.FirstName}} {{n.LastName}} ({{n.SiteName}})</li>
        </ul>

        <p *ngIf="!WindowNeeded">A tie-breaker round window already exists. Go to the Edit Window page and verify the dates and times are correct.</p>

        <div *ngIf="WindowNeeded">
            <p>You must schedule a tie-breaking round by specifying the starting and ending dates/times below.</p>

            <div fxLayout="row" fxLayoutAlign="space-between center">
                <mat-form-field appearance="outline" fxFlex="20">
                    <input type="text" matInput placeholder="Beginning Date" formControlName="BeginDate" required [matDatepicker]="beginPicker" />
                    <mat-datepicker-toggle matSuffix [for]="beginPicker"></mat-datepicker-toggle>
                    <mat-datepicker #beginPicker></mat-datepicker>
                    <mat-error *ngIf="TieForm.get('BeginDate')?.hasError('required')">required</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="20">
                    <input type="text" matInput placeholder="Beginning Time" formControlName="BeginTime" required />
                    <mat-error *ngIf="TieForm.get('BeginTime')?.hasError('required')">required</mat-error>
                    <mat-error *ngIf="TieForm.get('BeginTime')?.hasError('pattern')">Time must be in HH:MM AM/PM format (ex: 7:00 AM)</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="20">
                    <input type="text" matInput placeholder="Ending Date" formControlName="EndDate" required [matDatepicker]="endPicker" />
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="TieForm.get('EndDate')?.hasError('required')">required</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="20">
                    <input type="text" matInput placeholder="Ending Date" formControlName="EndTime" required />
                    <mat-error *ngIf="TieForm.get('EndTime')?.hasError('required')">required</mat-error>
                    <mat-error *ngIf="TieForm.get('EndTime')?.hasError('pattern')">Time must be in HH:MM AM/PM format (ex: 11:59 PM)</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="checkbox">
            <mat-checkbox formControlName="AutoAssign">Automatically assign the same judges from this round to the tie-breaker round</mat-checkbox>
        </div>

        <p><strong>Note:</strong> If you choose to not automatically assign the same judges, you must add them manually in the Judge Tool.</p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
        <button mat-raised-button type="submit" [color]="'primary'">Schedule</button>
    </div>
</form>
